<template>
  <div>
    <slot v-if="isAdmin"> </slot>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'IsAdmin',
  data: function () {
    return {};
  },
  props: {},
  computed: {
    ...mapGetters(['isAdmin']),
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/toolbar/IsAdmin.vue